 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		"inline": 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "" + chunkId + "." + {"accordion.module":"a43c993902bf10c3737a","add-on.module":"d887074386207606a7ae","advance-elements.module":"a1e1df1507b9eb5f25e4","advance.module":"2e168ec885792da49128","alert.module":"52c04290de5957567e60","analytics.module":"fec424b473fd9cc1af14","animation.module":"29a6d9abfc6cdb0513c4","auth.module":"d6651bc5752d2031e15a","basic-color.module":"2f1c2adbe65a97bc5497","basic-elements.module":"f1409483c4f94c73eecb","basic-invoice.module":"304421a463f8e39618d6","basic-list.module":"e4b653f505f9268eced3","basic-login.module":"23a63db68bf1ed12a034","basic-other.module":"f08cde63da64a204a1c8","basic-reg.module":"788f4b2b4541f7981e53","basic.module":"cd3a45c8d2846714e701","bootstrap-table.module":"94f087d671020bf41120","border.module":"33a02a69a7fb23a11ea0","box-shadow.module":"802c22308f869d320812","breadcrumb.module":"d77eedf99b06c33ed1ed","button.module":"86d0083a73c30d5c62ee","c3-js.module":"3b1d179f14f9cc796278","carousel.module":"f2a1828def0e633f3db5","chart-js.module":"50212e218524c9c9c591","chart-widget.module":"2cc005f8db2f9e268d1f","chart.module":"c48fadde72f9a169893d","coming-soon.module":"9e083a6a1bcb91591a7a","dashboard.module":"3786420f1332e9dd7067","data-table.module":"64932443d7aa67cac254","data-widget.module":"d2ed7c1db236679fdc65","default.module":"5fdaf6f4e885dd3f9146","ecommerce.module":"48339b9130ac17e57159","error.module":"a18fc72d828acf704ffc","file-upload-ui.module":"1ff531f8947f65e0dca0","forgot.module":"857b1938458fdadf66ad","form-picker.module":"144f647cc26242aeceb8","form-select.module":"7b499a06701d9a410fac","form-validation.module":"ac40b383b72865fd0d25","forms.module":"a74bb2ca3a8b507cb455","generic-class.module":"c5189b2153edf4e27644","google-chart.module":"c8b262edcc08355eb536","google-map.module":"9aca77e6318b9d0288d8","header-footer-login.module":"a1ee8aba6211d5982ed0","header-footer-reg.module":"5609b9371f0d047e6e54","invoice-list.module":"556ecb5ed63a8f7364aa","invoice-summary.module":"f8358e08e324ede7c64e","invoice.module":"57d81626c90ac8ea9742","label-badge.module":"9e5af41e9a270655a28b","lock-screen.module":"d15f816c681fb69e5728","login.module":"7768374d5b08ac10dba1","map.module":"291d35f52750b4282fdc","modal.module":"a3c753ca040458eed3e9","navigation.module":"3714d3d66d940a76f11d","notification.module":"574f1244d6bba231e6cf","notify.module":"72d4391daee5a7783541","offline-ui.module":"fddb84e216443ba2c330","paging.module":"1f5bc2a4e282c0a398b1","pre-loader.module":"31a6b3e49238070c0941","progressbar.module":"18e06f54317818799a4d","radial.module":"052cca0d54407b719c68","rating.module":"88e560409e37d4811b39","registration.module":"957edb4107eaa5dec7dd","row-details.module":"db624a3c547a2e8518ab","selection.module":"7caa47582173350fcdc1","simple-page.module":"1a07a0a1bf2d9abb62c8","sizing.module":"b35de622cbf318eac38e","social-header-footer-login.module":"b1fd62d1cf6ef6c32ae5","social-header-footer-reg.module":"fba638c5e1a6752c8bb7","social-login.module":"ba29ff4fa5f01098bff3","social-reg.module":"3b5bdb5a416b1e534a3e","statistic.module":"1bf3832b14b728099d45","styling.module":"3b707821b6815f08d104","table-basic-data.module":"0df70b0c98e02a5eb50f","table-basic.module":"4f348bfbdbd079886e6b","table-edit.module":"0a8194c6fb11af392650","tabs.module":"9e05ff9ab4a4b7c5d104","task-board.module":"5fb9cccdb4c4a94a7e81","task-details.module":"38257da8894b415927e2","task-issue.module":"5f908adc142eaf15bf15","task-list.module":"de73d2d105980f51c6df","task.module":"31c27770dcbc3d17b481","tooltip.module":"491cb6513dc9f4edfc24","typography.module":"56df933d5b6b678d2382","user-card.module":"95b7dd7302d957f416c3","user-profile.module":"7ac906c374ecda5138be","user.module":"c930c06e85420ecae504","widget.module":"7d0784def4a19de2a05c","common":"78d7ce702e038fda4dbb"}[chunkId] + ".chunk.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 5320ea877ac53fb4935b